import { pl } from './pl/';
import { en } from './en/';

export const LANGS = { pl, en };
export const GETQuery = 'pdf=true';
